import { render, staticRenderFns } from "./passwordSecurity.vue?vue&type=template&id=a37dc3c0&scoped=true"
import script from "./passwordSecurity.vue?vue&type=script&lang=js"
export * from "./passwordSecurity.vue?vue&type=script&lang=js"
import style0 from "./passwordSecurity.vue?vue&type=style&index=0&id=a37dc3c0&prod&lang=scss&scoped=true"
import style1 from "./passwordSecurity.vue?vue&type=style&index=1&id=a37dc3c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37dc3c0",
  null
  
)

export default component.exports